<template>
  <basic-container>
    <avue-crud :option="option"
               :table-loading="loading"
               :data="data"
               :page.sync="page"
               :permission="permissionList"
               v-model="form"
               ref="crud"
               @row-update="rowUpdate"
               @row-save="rowSave"
               @row-del="rowDel"
               @search-reset="searchReset"
               @selection-change="selectionChange"
               @current-change="currentChange"
               @size-change="sizeChange"
               @refresh-change="onLoad"
               >
      <template slot="search">
          <el-row style="display:flex;justify-content: space-between;width: 100%;">


            <el-col span="6">
                 <el-form-item label="优惠券名称">
              <el-select
                  v-model="couponId"

                  style="width: 100%;"
                  placeholder="优惠券名称"
                >
                  <el-option
                    v-for="item in couponShopRecordList"
                    :key="item.couponId "
                    :label="item.couponName"
                    :value="item.couponId "
                  >
                  </el-option>
              </el-select>
          </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item label="优惠券总数">
                  <el-input v-model="totalCoupons" disabled></el-input>
              </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item label="使用数量">
                        <el-input v-model="usedCoupons" disabled></el-input>
              </el-form-item>
          </el-col>
            <el-col span="6" style="text-align:right;">
              <el-button style="margin-left:20px;height: 35px;"  type="primary" size="small" icon="el-icon-search" @click="searchChange">搜 索</el-button>
            </el-col>
           </el-row>
      </template>

      <template slot-scope="scope" slot="parkingLotIdSearch">
        <el-select
          v-model="parkingLotIdQuery"
          filterable
          @change="parkingLotQueryChanged"
          style="width: 100%;"
          placeholder="车场名称"
        >
          <el-option
            v-for="item in spaceList"
            :key="item.id"
            :label="item.title"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </template>
      <template slot-scope="scope" slot="shopIdSearch">
        <el-select
          v-model="shopId"
          style="width: 100%;"
          placeholder="商家名称"
          @change="searchShopChange"
        >
          <el-option
            v-for="item in shopSelectionsList"
            :key="item.id"
            :label="item.shopName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </template>
      <template slot-scope="scope" slot="giveOutTimeRangeSearch">
        <el-date-picker
          v-model="giveOutTimeRange"
          type="datetimerange"
          :style="{'width':'100%'}"
          value-format="yyyy-MM-dd HH:mm:ss"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
        >
        </el-date-picker>
      </template>
      <template slot="menuLeft">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-plus"
                   @click="beforeOpen('add')">发券
        </el-button>
      </template>
      <template slot="menu" slot-scope="scope">
        <el-button type="text"
                   size="small"
                   icon="el-icon-edit"
                   @click="beforeOpen('edit',scope.row)">编辑
        </el-button>
        <el-button type="text"
                   size="small"
                   icon="el-icon-download"
                   @click="getQrcode(scope.row.id,scope.row.shopName)">二维码
        </el-button>
      </template>
    </avue-crud>
    <el-dialog
      id="coupon_give_out"
      :title="title"
      :visible.sync="showCouponGiveOutDialog"
      :modal-append-to-body="false"
      width="60%"
      @close="closeDialog"
    >
      <el-row v-if="showCouponGiveOutDialog">
        <el-form ref="giveOutForm" :model = "giveOutForm"  label-width="100px" margin-top="0">
          <el-col span="12">
            <el-form-item label="车场名称" prop="parkingLotId"
                          :rules="[{ required: true, message: '请选择车场名称', trigger: 'change' },]">
              <el-select
                v-model="giveOutForm.parkingLotId"
                style="width: 100%;"
                placeholder="车场名称"
                :disabled='disabled'
                @change="giveOutParkingLotChange"
              >
                <el-option
                  v-for="item in spaceList"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col span="12">
            <el-form-item label="商家名称" prop="shopId"
                          :rules="[{ required: true, message: '请选择商家名称', trigger: 'change' },]">
              <el-select
                v-model="giveOutForm.shopId"
                style="width: 100%;"
                placeholder="商家名称"
                :disabled='disabled'
                @change="shopChanged"
              >
                <el-option
                  v-for="item in shopNormalList"
                  :key="item.id"
                  :label="item.shopName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="优惠券" prop="couponId"
                          :rules="[{ required: true, message: '请选择优惠券', trigger: 'change' },]">
              <el-select
                v-model="giveOutForm.couponId"
                style="width: 100%;"
                placeholder="优惠券"
                :disabled='disabled'
                filterable
                @change="chopChanged"
              >
                <el-option
                  v-for="item in couponList"
                  :key="item.couponId"
                  :label="item.couponName"
                  :value="item.couponId"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="二维码截至" prop="expireDate"
                          :rules="[{ required: true, message: '请选择日期时间', trigger: 'blur' },]">
               <el-date-picker
                  v-model="giveOutForm.expireDate"
                  type="datetime"
                  style="width:100%"
                  placeholder="选择日期时间">
                </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col span="24" style="text-align:right;" id="button-back">
            <el-button type="primary" icon="el-icon-circle-check" size="small" @click="saveData" >保 存
            </el-button>
            <el-button icon="el-icon-circle-close" size="small" @click="showCouponGiveOutDialog = false" >返回</el-button>
          </el-col>
        </el-form>
      </el-row>
    </el-dialog>
  </basic-container>
</template>

<script>
  import { save,
   shopSelections,
   getList,
   remove,
   update,
   getCouponShopRecordList,//优惠券下拉框接口
   getCouponReceiveNumSumByShopId,
   getCouponSumByShopId,
   cancel} from '@/api/v4ward/park/coupon/giveout/carcoupongiveout';

  import { getSpaceTree } from '@/api/v4ward/car/carparkspace';
  import { isvalidatemobile } from '@/util/validate';
  import func from '@/util/func';
  import qrcode from 'qrcodejs2';
  export default {
    data() {
      const validatePhone = (rule, value, callback) => {
        if (isvalidatemobile(value)[0]) {
          callback(new Error(isvalidatemobile(value)[1]));
        } else {
          callback();
        }
      };
      return {
        form: {},
        query: {},
        loading: true,
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0,
        },
        totalCoupons:0,
        usedCoupons:0,
        title:'优惠券派发',
        shopSelectionsList:[],//商家下拉框数据
        shopId: '',//商家id
        spaceList: [],//车场下拉框数据
        parkingLotIdQuery:'',//车场id
        couponShopRecordList:[],//优惠券下拉框数据
        couponId:'',//优惠券id

        option: {
          height: 'auto',
          calcHeight: 30,
          tip: false,
          viewBtn:false,
          delBtn:false,
          searchShow: true,
          searchMenuSpan: 24,
          searchMenuPosition:'left',
          border: true,
          index: true,

          dialogClickModal: false,
          align: 'center',
          //menu: false,
          stripe:true,
          columnBtn: true,
          refreshBtn: true,
          emptyBtn: false,
          addBtn: false,
          menuWidth: 160,
          searchBtn:false,
          editBtn:false,
          column: [
            {
              label: '车场名称',
              prop: 'parkingLotId',
              type: 'select',
              hide: true,
              search: true,
              searchSpan: 6,
              searchslot: true,
              dicData: [],
              width: 150,
              props: {
                label: 'title',
                value: 'id',
                disabled: 'disabled',
              },
              rules: [{
                required: true,
                message: '请选择车场名称',
                trigger: 'change',
              }],
            },
            {
              label: '商家名称',
              prop: 'shopId',
              type: 'select',
              overHidden: true,
              //display: false,
              searchSpan: 6,
              search:true,
              hide:true,
              dicData: [],
              searchslot: true,
              props: { label: 'shopName', value: 'id'},
            },
            {
              label: '派发时间',
              prop: 'issueTime',
              width: 140,
            },
            {
              label: '派发时间',
              prop: 'giveOutTimeRange',
              hide: true,
              clearable:false,
              type: 'select',
              display: false,
              searchSpan: 12,
              required:true,
              rules:[
                {
                  required:true,
                  message:'请选择时间段后再查询',
                  trigger:'blur'
                }
              ],
              search: true,
              searchslot: true,
            },
            {
              label: '商家名称',
              prop: 'shopName',
              type: 'select',
              overHidden: true,
              searchSpan: 4,
              dicData: [],
              props: { label: 'shopName', value: 'id'},
            },
            {
              label: '优惠券名称',
              prop: 'couponName',

              overHidden: true,

              rules: [{
                required: true,
                message: '请输入优惠券名称',
                trigger: 'change',
              }],
            },
            {
              label: '优惠券类型',
              prop: 'couponType',
              dataType: 'number',
              type:'select',
              width: 100,
              dicUrl: '/api/blade-system/dict/dictionary?code=car_coupon_type',
              props: { label: 'dictValue', value: 'dictKey'},
            },
            {
              label: '已领数量',
              prop: 'receiveNum',
            },
            {
              label: '有效期',
              prop: 'expireDate',
              width: 140,
              rules: [{
                required: true,
                message: '请输入有效截止日期',
                trigger: 'change',
              }],
            },
            {
              label: '发券人',
              prop: 'sendName',
            },


          ],
        },
        disabled:false,
        data: [],
        couponList: [],
        //未删除的商家且未欠费的商家
        shopNormalList: [],//新增表单里面的商家下拉框数据
        filterLetterList: [],
        parkingLotId: '',
        firstDisplayFlag: true,
        showCouponGiveOutDialog: false,
        giveOutTimeRange: '',
        giveOutForm: {
          parkingLotId: '',
          shopId: '',
          couponId: '',
          expireDate:'',
        },
        submitFlag:true,
      };
    },
    activated() {
      let self = this;
      setTimeout(() => {
        this.$refs.crud.doLayout(); //解决表格错位
      }, 0);
    },
    created() {
      this.option.height = this.bodyHeight - 380;
      this.initData();

    },
    mounted(){
      this.$nextTick(() => {
      setTimeout(()=>{
              document.querySelector('#avue-view  div.avue-crud > div.avue-crud__menu > div.avue-crud__right > button:nth-child(3)').addEventListener("click", ()=>{

                      if(this.option.height == this.bodyHeight - 380){
                      this.option.height = this.bodyHeight - 280
                      }else{
                      this.option.height = this.bodyHeight - 380;
                      }
                      this.$refs.crud.getTableHeight();
              });
              },1000)

      });
    },
    activated() {
      let self = this;
      setTimeout(() => {
        this.$refs.crud.doLayout(); //解决表格错位
      }, 0);
    },
    computed: {
      ids() {
        let ids = [];
        this.selectionList.forEach(ele => {
          ids.push(ele.id);
        });
        return ids.join(',');
      },
    },
    methods: {
      // 初始化数据
      async initData(){

         // 初始化派单时间段

        //var startTime = func.() + ' 00:00:00';
        //var endTime = func.getCurrentDay() + ' 23:59:59';
        //this.giveOutTimeRange = [startTime, endTime];

        // 获取车场下拉框
        await getSpaceTree().then((data) => {
            this.spaceList = data.data;
            this.parkingLotIdQuery = this.spaceList[0]?this.spaceList[0].id:'';
        });
        if(!this.parkingLotIdQuery){
          this.onLoad();
            return;
        }
        // 获取商家下拉框
        await shopSelections({parkingLotId:this.parkingLotIdQuery,byShopUser:1}).then(res=>{
            this.shopSelectionsList = res.data;
            this.shopId = this.shopSelectionsList[0]?this.shopSelectionsList[0].id:'';
        })
        if(!this.shopId){
            this.onLoad();
            return;
        }
        // 获取优惠券下拉框数据
        await getCouponShopRecordList({shopId:this.shopId}).then(res=>{
            this.couponShopRecordList = res.data;
            // this.couponId = this.couponShopRecordList?this.couponShopRecordList.couponId:'';
        })


        this.onLoad();
      },
      // 获取二维码
      getQrcode(id, fileName) {
            let origin = window.location.origin;
            if(origin.indexOf('location')>-1){
              origin = 'http://cp-test.4ggo.net';
            }
            let url = origin + '/h5/carcharge/#/coupon-index?id=' + id;
            var div = document.createElement('div');
            var code = new qrcode(div, {
              text: url,
              width: 500,
              height: 500,
              colorDark: '#000000',
              colorLight: '#ffffff',
              correctLevel: qrcode.CorrectLevel.H,
            });
            let canvas = code._el.querySelector('canvas');
            var base64Text = canvas.toDataURL('image/png');
            var blob = this.getBlob(base64Text);
            if (navigator.msSaveBlob) {
              // IE的Blob保存方法
              navigator.msSaveBlob(blob, fileName);
            } else {
              var link = document.createElement('a');
              var href = window.URL.createObjectURL(blob);
              link.href = href;
              link.download = fileName;
              document.body.appendChild(link); // firefox需要把a添加到dom才能正确执行click
              link.click();
              // 延时保证下载成功执行，否则可能下载未找到文件的问题
              setTimeout(function () {
                window.URL.revokeObjectURL(href); // 释放Url对象
                document.body.removeChild(link);
              }, 100);
            }
      },
      // 解析base64
      getBlob(base64) {
        var mimeString = base64.split(',')[0].split(':')[1].split(';')[0]; // mime类型
        var byteString = atob(base64.split(',')[1]); //base64 解码
        var arrayBuffer = new ArrayBuffer(byteString.length); //创建缓冲数组
        var intArray = new Uint8Array(arrayBuffer); //创建视图
        for (var i = 0; i < byteString.length; i += 1) {
          intArray[i] = byteString.charCodeAt(i);
        }
        return new Blob([intArray], {
          type: mimeString,
        });
      },
      // 获取商家下拉框
      shopSelections(type){
          if(type=="search"){ //搜索表单中的获取下拉框数据
              shopSelections({parkingLotId:this.parkingLotIdQuery,byShopUser:1}).then(res=>{
                this.shopSelectionsList = res.data;
                this.shopId = this.shopSelectionsList[0]?this.shopSelectionsList[0].id:'';
                  if(this.shopId){
                    this.getCouponShopRecordList('search');
                  }
              })
          }
          if(type=="add"){ //弹窗表单数据中获取下拉框数据
              shopSelections({parkingLotId:this.giveOutForm.parkingLotId,byShopUser:1}).then(res=>{
                  this.shopNormalList = res.data;
                  this.giveOutForm.shopId = this.shopNormalList[0]?this.shopNormalList[0].id:'';
                  if(this.giveOutForm.shopId){
                    this.getCouponShopRecordList('add');
                  }
              })
          }
          if(type=="edit"){ //弹窗表单数据中获取下拉框数据
              shopSelections({parkingLotId:this.giveOutForm.parkingLotId,byShopUser:1}).then(res=>{
                  this.shopNormalList = res.data;
                  if(this.giveOutForm.shopId){
                    this.getCouponShopRecordList('edit');
                  }
              })
          }

      },
      // 获取优惠券下拉框 type 用来控制不同表单中的
      getCouponShopRecordList(type){
          if(type=="search"){
              getCouponShopRecordList({shopId:this.shopId}).then(res=>{
                this.couponShopRecordList = res.data;
                this.couponId = '';
                // this.couponId = this.couponShopRecordList[0]?this.couponShopRecordList[0].couponId:'';
              })
          }
          if(type=="add"){
              getCouponShopRecordList({shopId:this.giveOutForm.shopId}).then(res=>{
                  this.couponList = res.data;
                  this.giveOutForm.couponId = '';
                  // this.giveOutForm.couponId = this.couponList[0]?this.couponList[0].couponId:'';
              })
          }
          if(type=="edit"){
              getCouponShopRecordList({shopId:this.giveOutForm.shopId}).then(res=>{
                  this.couponList = res.data;
              })
          }

      },
      // 打开弹窗
      beforeOpen(type,row) {
        this.submitFlag = true;
        if(type=="add"){
          this.title = "优惠券派发";
          this.disabled = false;
          this.giveOutForm = {
              parkingLotId: '',
              shopId: '',
              couponId: '',
              expireDate:'',
          };
          if(this.spaceList.length>0){
            this.giveOutForm.parkingLotId = this.spaceList[0].id;
            this.shopSelections('add');
          }
          this.showCouponGiveOutDialog = true;
        }
        if(type=="edit"){
          this.title = "编辑";
          this.disabled = true;
          this.giveOutForm = row;
          this.giveOutForm = {
              parkingLotId: row.parkingLotId,
              shopId: row.shopId,
              couponId: row.couponId,
              expireDate:row.expireDate,
              id:row.id
          };
          this.shopSelections('edit');
          this.showCouponGiveOutDialog = true;
        }

      },
      // 保存提交方法
      saveData() {
        this.$refs.giveOutForm.validate((valid) => {
          if (valid) {
            if(!this.submitFlag){
              return;
            }
            this.submitFlag = false;
            this.giveOutForm.expireDate = this.dayjs(this.giveOutForm.expireDate).format('YYYY-MM-DD HH:mm:ss');
            if(this.title=='编辑'){
              // 编辑
              update(this.giveOutForm).then(() => {
                this.onLoad();
                this.$message.success('操作成功!');
                this.submitFlag = true;
                this.showCouponGiveOutDialog = false;
              }, error => {
                this.submitFlag = true;
                window.console.log(error);
              });
            }else{
              // 新增
              save(this.giveOutForm).then(() => {
                this.onLoad();
                this.$message.success('操作成功!');
                this.submitFlag = true;
                this.showCouponGiveOutDialog = false;
              }, error => {
                this.submitFlag = true;
                window.console.log(error);
              });
            }

          } else {
          }
        });
      },

      //派发表单中修改了车场
      giveOutParkingLotChange(value){
          this.giveOutForm.couponId = '';
          this.giveOutForm.shopId = '';
          this.shopSelections('add');
      },
      // 发券表单商家切换
      shopChanged(){
        this.giveOutForm.couponId = '';
        this.getCouponShopRecordList('add');
      },
      // 搜索表单车场切换
      parkingLotQueryChanged(value) {
        this.shopId = '';
        this.couponId = '';
        this.shopSelections('search');
      },
      // 搜索表单商家切换
      searchShopChange(value){
        this.couponId = '';
        this.getCouponShopRecordList('search');
      },
      // 搜索
      searchChange(params, done) {
        this.query = params;
        this.page.currentPage = 1;
        this.onLoad();
        done();
      },
      // 切换页
      currentChange(currentPage) {
        this.page.currentPage = currentPage;
      },
      // 切换一页接收多少条数据
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
      },
      onLoad(page) {
        page = page || this.page;
        this.loading = true;
        this.query.parkingLotId = this.parkingLotIdQuery;
        this.query.shopId = this.shopId;
        this.query.couponId = this.couponId;
        if(!this.query.shopId){
          this.loading = false;
          return;
        }

        if(this.giveOutTimeRange){
          this.query.timeStart = this.dayjs(this.giveOutTimeRange[0]).format('YYYY-MM-DD HH:mm:ss');
          this.query.timeEnd = this.dayjs(this.giveOutTimeRange[1]).format('YYYY-MM-DD HH:mm:ss');
        }else{
          this.query.timeStart = '';
          this.query.timeEnd = '';
        }

        getList(
          Object.assign({ current: page.currentPage, size: page.pageSize }, this.query),
        ).then(({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }).catch(err=>{
          this.loading = false;
        })
        // 获取已使用优惠券数量
        getCouponReceiveNumSumByShopId(this.query).then(res=>{
          this.usedCoupons = res.data;
        })
        // 获取优惠券总数
        getCouponSumByShopId(this.query).then(res=>{
          this.totalCoupons = res.data;
        })
      },
    },
  };
</script>

<style>
  #coupon_give_out .el-dialog__body {
    padding-right: 60px;
  }

  #button-back .el-button + .el-button {
    /* margin-left: 50px; */
    /* margin-top: 20px;
    margin-bottom: 20px; */
  }

  #button-back .el-button--small {
    /* padding: 9px 20px; */
  }
</style>
<style scoped>

  ::v-deep .avue-form__menu--center{
    text-align: right;
  }
::v-deep   .avue-crud__search .el-form-item--small.el-form-item{
    width: 100%;
  }
</style>